// extracted by mini-css-extract-plugin
module.exports = {"root":"ForegroundCanvas_root__6DUzD"};